import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icons from '../../../../../components/Common/Icons/Icons';
import MenuIcon from '../../../Layout/Menu/MenuIcon';
import { Button } from '../../../../../components/Common/UI/Button';
import Link from '../../../../../components/Common/UI/Link';
import { IPageHeader } from '../index';
import UserMenu from '../../UserMenu';

function DesktopPageHeader({ icon, title, actions, disableDownloadBtn }: IPageHeader) {
  const navigate = useNavigate();

  return (
    <div
      className="p-[15px_20px] h-[90px] relative
    before:absolute before:bg-secondary before:left-[-10px] before:right-0 before:h-[135px]
    before:top-0 before:z-0 justify-between items-center lg:flex hidden"
    >
      <div className="relative">
        <div className="text-white font-bold text-xl flex gap-[10px] items-center">
          <MenuIcon icon={icon} variant="header" size="large" />
          <div>{title}</div>
        </div>
      </div>
      <div className="relative flex items-center gap-[20px]">
        {actions}
        {!disableDownloadBtn ? (
          <Button
            variant="outline"
            className="p-[10px_15px] !text-white font-bold !bg-transparent border-white"
            onClick={() => navigate('/guidance/batch-download')}
          >
            Batch Download Documents
          </Button>
        ) : null}
        {/* <Link to="/guidance/profile">
          <MenuIcon icon={<Icons.User />} variant="header" size="large" />
        </Link> */}
        <UserMenu />
      </div>
    </div>
  );
}

export default DesktopPageHeader;
